<template>
  <div class="auth-confirm-dialog">
    <van-dialog
      v-model:show="authPopupConfig.isShow"
      class="private-dialog-customize single-btn"
      :confirm-button-text="$t('public.Confirm')"
    >
      <div class="content">
        <div class="images flex s-b">
          <div class="item">
            <img
              class="item-img"
              src="@/assets/image/privateDialog/video-icon.png"
              alt=""
            />
            <img
              class="warn-icon"
              src="@/assets/image/privateDialog/warn-icon.png"
              alt=""
            />
          </div>
          <div class="item">
            <img
              class="item-img"
              src="@/assets/image/privateDialog/audio-icon.png"
              alt=""
            />
            <img
              class="warn-icon"
              src="@/assets/image/privateDialog/warn-icon.png"
              alt=""
            />
          </div>
        </div>
        <div class="txt">{{ $t('call.authMessage') }}</div>
      </div>
    </van-dialog>
  </div>
</template>

<!-- 全局按钮
  import { showConfirmDialog } from 'vant'
  import i18n from '@/language/index'

  单按钮
   showConfirmDialog({
      message: '内容',
      confirmButtonText: i18n.global.t('public.Confirm'),
      showCancelButton: false,
      className: 'private-dialog-customize single-btn'
    })
    .then(() => {
      })
      .catch(() =>{})

  双按钮
  showConfirmDialog({
      message: '内容',
      confirmButtonText: i18n.global.t('public.Yes'),
      cancelButtonText: i18n.global.t('public.No'),
      className: 'private-dialog-customize'
    })
      .then(() => {
      })
      .catch(() => {
      })

-->

<!-- 确认按钮弹出框-授权
  <AuthConfirmDialog />
-->
<script setup lang="ts">
defineOptions({ name: 'AuthConfirmDialog' })

// 公共模块store
const agoraStore = useAgoraStore()
const { authPopupConfig } = storeToRefs(agoraStore)
</script>

<style lang="scss" scoped>
.auth-confirm-dialog {
  .content {
    padding: 26px 6px 26px;

    .images {
      padding: 0 65px;

      .item {
        position: relative;
        @include wh(74px, 74px);

        .item-img {
          @include wh(74px, 74px);
        }

        .warn-icon {
          position: absolute;
          right: 0;
          bottom: 4px;
          @include wh(20px, 20px);
        }
      }
    }

    .txt {
      margin-top: 12px;
      text-align: center;
      @include font-style(14px, #fff);
      line-height: 1.5;
    }
  }
}
</style>
